import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Seatingplan, Sponsor, SponsorCodeModel, SponsorCodeUsageModel, TicketQuota } from "../../models";
import { UnsafeAction } from "../../actions/UnsafeAction";
import { SponsorsFreeSeating } from "../../models/sponsors-freeSeating.model";

/* tslint:disable */
@Injectable()
export class SponsorActions {

	static LOAD_SPONSOR_LIST = "[SPONSOR] Load Sponsor List"

	public loadSponsorList(): Action {
		return {
			type: SponsorActions.LOAD_SPONSOR_LIST
		}
	}

	static LOAD_SPONSOR_LIST_SUCCESS = "[SPONSOR] Load sponsor list success"

	public loadSponsorListSuccess(sponsors): UnsafeAction {
		return {
			type: SponsorActions.LOAD_SPONSOR_LIST_SUCCESS,
			payload: sponsors
		}
	}

	static LOAD_SPONSOR = "[SPONSOR] Load Sponsor"

	public loadSponsor(sponsorId: string): UnsafeAction {
		return {
			type: SponsorActions.LOAD_SPONSOR,
			payload: sponsorId
		}
	}

	static LOAD_SPONSOR_SUCCSESS = "[SPONSOR] Load Sponsor success"

	public loadSponsorSuccess(sponsor: Sponsor): UnsafeAction {
		return {
			type: SponsorActions.LOAD_SPONSOR_SUCCSESS,
			payload: sponsor
		}
	}

	static LOAD_SPONSOR_CODES = "[SPONSOR] Load Sponsor Codes"

	public loadSponsorCodes(sponsorId: String): UnsafeAction {
		return {
			type: SponsorActions.LOAD_SPONSOR_CODES,
			payload: sponsorId
		}
	}

	static LOAD_SPONSOR_CODES_SUCCESS = "[SPONSOR] Load Sponsor Codes success"

	public loadSponsorCodesSuccess(sponsorCodes: SponsorCodeModel[]): UnsafeAction {
		return {
			type: SponsorActions.LOAD_SPONSOR_CODES_SUCCESS,
			payload: sponsorCodes
		}
	}

	static SPONSOR_CODE_LOADED = "[SPONSOR] Sponsor Code loaded"

	public sponsorCodeLoaded(sponsorCode: SponsorCodeModel): UnsafeAction {
		return {
			type: SponsorActions.SPONSOR_CODE_LOADED,
			payload: sponsorCode
		}
	}

	static LOAD_SPONSOR_CODE_BY_ID = "[SPONSOR] Load Sponsor Code by Id"

	public loadSponsorCodeById(sponsorCodeId: string): UnsafeAction {
		return {
			type: SponsorActions.LOAD_SPONSOR_CODE_BY_ID,
			payload: sponsorCodeId
		}
	}

	static LOAD_SPONSOR_CODE_USAGES = "[SPONSOR] Load Sponsor Code Usages"

	public loadSponsorCodeUsages(sponsorCodeId: String): UnsafeAction {
		return {
			type: SponsorActions.LOAD_SPONSOR_CODE_USAGES,
			payload: sponsorCodeId
		}
	}

	static LOAD_SPONSOR_CODE_USAGES_SUCCESS = "[SPONSOR] Load Sponsor Code Usages success"

	public loadSponsorCodeUsagesSuccess(sponsorCodeUsages: SponsorCodeUsageModel[]): UnsafeAction {
		return {
			type: SponsorActions.LOAD_SPONSOR_CODE_USAGES_SUCCESS,
			payload: sponsorCodeUsages
		}
	}

	static SPONSOR_CODE_USAGE_LOADED = "[SPONSOR] Sponsor Code Usage loaded"

	public sponsorCodeUsageLoaded(sponsorCodeUsage: SponsorCodeUsageModel): UnsafeAction {
		return {
			type: SponsorActions.SPONSOR_CODE_USAGE_LOADED,
			payload: sponsorCodeUsage
		}
	}

	static CLEAR_SELECTED_CODE_USAGE= "[SPONSOR] Clear Selected Code Usage"

	public clearSelectedCodeUsage(): Action {
		return {
			type: SponsorActions.CLEAR_SELECTED_CODE_USAGE,
		}
	}

	static LOAD_SPONSOR_CODE_USAGE_BY_ID = "[SPONSOR] Load Sponsor Code Usage by Id"

	public loadSponsorCodeUsageById(sponsorCodeUsageId: string): UnsafeAction {
		return {
			type: SponsorActions.LOAD_SPONSOR_CODE_USAGE_BY_ID,
			payload: sponsorCodeUsageId
		}
	}

	static LOAD_CODE_USAGE_EVENT_LIST = "[SPONSOR] Load Code Usage Event List"

	public loadCodeUsageEventList(): Action {
		return {
			type: SponsorActions.LOAD_CODE_USAGE_EVENT_LIST
		}
	}

	static LOAD_CODE_USAGE_EVENT_LIST_SUCCESS = "[SPONSOR] Load Code Usage Event List success"

	public loadCodeUsageEventListSuccess(events): UnsafeAction {
		return {
			type: SponsorActions.LOAD_CODE_USAGE_EVENT_LIST_SUCCESS,
			payload: events
		}
	}

	static LOAD_SEATS_BY_CODE_USAGE_ID = "[SPONSOR] Load Seats for code usage"

	public loadSeatsForCodeUsage(codeUsageId: string): UnsafeAction {
		return {
			type: SponsorActions.LOAD_SEATS_BY_CODE_USAGE_ID,
			payload: codeUsageId
		}
	}

	static SEATS_LOADED = "[SPONSOR] Seats for code usage loaded"

	public seatsForCodeUsageLoaded(seats: string[]): UnsafeAction {
		return {
			type: SponsorActions.SEATS_LOADED,
			payload: seats
		}
	}

	static LOAD_FS_BY_CODE_USAGE_ID = "[SPONSOR] Load FreeSeatings for code usage"

	public loadFreeSeatingsForCodeUsage(codeUsageId: string): UnsafeAction {
		return {
			type: SponsorActions.LOAD_FS_BY_CODE_USAGE_ID,
			payload: codeUsageId
		}
	}

	static FS_LOADED = "[SPONSOR] FreeSeatings for code usage loaded"

	public freeSeatingsForCodeUsageLoaded(freeSeatings: SponsorsFreeSeating[]): UnsafeAction {
		return {
			type: SponsorActions.FS_LOADED,
			payload: freeSeatings
		}
	}

	static SET_RESERVATIONS_BY_EVENT_UUID = "[SPONSOR] Set Reservations for event of code usage"

	public setReservationsByEventUuid(reservations: { seats: String[], freeSeatings: SponsorsFreeSeating[] }): UnsafeAction {
		return {
			type: SponsorActions.SET_RESERVATIONS_BY_EVENT_UUID,
			payload: reservations
		}
	}

	static CLEAR_SP_DATA = "[SPONSOR] Clear SP Data"

	public clearSpData(): Action {
		return {
			type: SponsorActions.CLEAR_SP_DATA,
		}
	}

	static SP_EVENT_LOADED = "[SPONSOR] SP Event loaded"

	public spEventLoaded(event): UnsafeAction {
		return {
			type: SponsorActions.SP_EVENT_LOADED,
			payload: event
		}
	}

	static SP_VENUE_LOADED = "[SPONSOR] SP Venue loaded"

	public spVenueLoaded(venue): UnsafeAction {
		return {
			type: SponsorActions.SP_VENUE_LOADED,
			payload: venue
		}
	}

	static SEATINGPLAN_LOADED = "[SPONSOR] Seatingplan loaded";

	seatingplanLoaded(seatingplan: Seatingplan): UnsafeAction {
		return {
			type: SponsorActions.SEATINGPLAN_LOADED,
			payload: seatingplan
		}
	}

	static TICKET_QUOTAS_LOADED = "[SPONSOR] Ticket quotas loaded";

	ticketQuotasLoaded(tqCollection: TicketQuota[]): UnsafeAction {
		return {
			type: SponsorActions.TICKET_QUOTAS_LOADED,
			payload: tqCollection
		}
	}

	static SP_CATEGORY_LOADED = "[SPONSOR] SP Category loaded"

	public spCategoryLoaded(category): UnsafeAction {
		return {
			type: SponsorActions.SP_CATEGORY_LOADED,
			payload: category
		}
	}
	
	static SP_PRICELEVEL_LOADED = "[SPONSOR] SP pricelevel loaded"
	
	public spPriceLevelLoaded(pricelevel): UnsafeAction {
		return {
			type: SponsorActions.SP_PRICELEVEL_LOADED,
			payload: pricelevel
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/sponsors/sponsor.actions.ts